// 3rd party
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

// Models
import { OrganizationModel } from '../models/organization.model';
import { StudyModel } from '../models/study.model';
import { SurveyModel } from '../models/survey.model';

// Services
import { AjaxService } from './ajax.service';

@Injectable()
export class StudyRequestService {
    constructor(private ajaxService: AjaxService) {}

    getBySlug(studySlug: string, include = '', language = null) {
        let includeParameter = '';
        let translationParameter = '';
        if (include.length > 0) {
            includeParameter = `?include=${include}`;
        }

        if(language) {
            translationParameter = (includeParameter) ? '&' : '?';
            translationParameter += `translate=${language}`;
        }

        return this.ajaxService.get(`/standalone/studies/${studySlug}${includeParameter}${translationParameter}`)
            .map(response => {
                response.data = new StudyModel(response.data);
                response.included.forEach((includedItem, index) => {
                    switch (includedItem.type) {
                        case 'organizations':
                            response.included[index] = new OrganizationModel(includedItem);
                            break;

                        case 'surveys':
                            response.included[index] = new SurveyModel(includedItem);
                            break;
                   }
                });

                return response;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/study-request.service.ts